import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SettingService {
  private token: string | null = null;
  subs = new Array();
  
  constructor(private http: HttpClient) { }  
    getStaffSettings(idStaff: string) {
      return this.http.get<any>(`${environment.apiUrl}/api/Settings/user/${idStaff}`,)
    }
    updateSettingsStaff(key: string, value: string, idStaff: string) {
      return this.http.post<any>(`${environment.apiUrl}/api/Settings/update/${key}/${value}/${idStaff}`, {})
    }
}
